import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { ReportService } from "../../../Report/report.service";
import { ReportFileTypeDialogComponent } from "../../shared/report-file-type-dialog/report-file-type-dialog.component";
import { DataService_Attendance } from "../shared/data.service";
import { StudentViewAttendanceHistoryComponent } from "./student-view-attendance-history/student-view-attendance-history.component";
import * as moment from "moment";

@Component({
	selector: "caass-attendance-history",
	templateUrl: "./attendance-history.component.html",
	styleUrls: ["./attendance-history.component.css"],
})
export class AttendanceHistoryComponent implements OnInit {
	constructor(
		private userService: UserService,
		private AttendanceTempService: DataService_Attendance,
		private dialogService: DialogService,
		private reportService: ReportService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		if (this.SelectedAttendance != undefined) {
			this.SelectedAttendanceHistory = null;
			this.loadAttendance();
		} else {
			this.lstAttendance = [];
			this.SelectedAttendanceHistory = null;
		}
	}

	ngOnChanges() {
		if (this.SelectedAttendance != undefined) {
			this.SelectedAttendanceHistory = null;
			this.loadAttendance();
		} else {
			this.lstAttendance = [];
			this.SelectedAttendanceHistory = null;
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SchoolID: any;
	@Input() SelectedAttendance: any;

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedAttendanceHistory: any;
	lstAttendance: any = [];

	//Filter lists
	lstAttendanceStatusDesc: any = [];
	lstExcuseDesc: any = [];
	lstEntryTypeDesc: any = [];
	lstRecordStatusDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "c_dateDesc", header: "Last Modified" },
		{ field: "AttendanceStatusDesc", header: "Status" },
		{ field: "ExcuseDesc", header: "Excuse" },
		{ field: "EntryTypeDesc", header: "Entry Type" },
		{ field: "EntryDTDesc", header: "Entry Date/Time" },
		{ field: "AdminName", header: "Created By" },
		{ field: "RecordStatusDesc", header: "Record Status" },
		{ field: "c_Comment", header: "Comments" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadAttendance() {
		this.loading = true;

		var result = this.AttendanceTempService.LoadAttendanceHistory(
			this.SelectedAttendance.PersonID,
			moment(this.SelectedAttendance.EntryDate).format("MM/DD/YYYY")
		);
		result.subscribe(
			(response) => {
				this.lstAttendance = response;

				//Load Data Filter Lists
				this.lstAttendanceStatusDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.AttendanceStatusDesc))).sort();
				this.lstExcuseDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.ExcuseDesc))).sort();
				this.lstEntryTypeDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.EntryTypeDesc))).sort();
				this.lstRecordStatusDesc = Array.from(new Set(this.lstAttendance.map((item: any) => item.RecordStatusDesc))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		if (this.SelectedAttendance != undefined) {
			this.SelectedAttendanceHistory = null;
			this.loadAttendance();
		} else {
			this.lstAttendance = [];
			this.SelectedAttendanceHistory = null;
		}
	}

	//Custom Button Methods
	onViewAttendance() {
		this.errorMessage = "";

		if (this.SelectedAttendanceHistory == undefined) {
			this.errorMessage = "Select an attendance history record to view";
			return;
		}

		var ref = this.dialogService.open(StudentViewAttendanceHistoryComponent, {
			header: "View Attendance History",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedAttendanceHistory: this.SelectedAttendanceHistory,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadAttendance();
			}
		});
	}

	onPrintAttendanceHistory() {
		this.errorMessage = "";

		//Error handling
		if (this.SchoolID == undefined) {
			this.errorMessage = "Select an attendance record to print";
			return;
		}

		if (this.SelectedAttendance == undefined) {
			this.errorMessage = "Select an attendance record to print";
			return;
		}

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrintAttendanceHistory(response);
			}
		});
	}

	FinishPrintAttendanceHistory(OutputType) {
		//Call SP

		var component = this;
		this.isProcessing = true;

		this.errorMessage = "";

		var strParam = "";

		//Parameter 1: PersonID
		strParam += this.SelectedAttendance.PersonID + "|PersonID";

		//Parameter 2: EntryDate
		strParam += "," + moment(this.SelectedAttendance.EntryDate).format("MM/DD/YYYY") + "|EntryDate";

		//Parameter 3: SchoolID
		strParam += "," + this.SchoolID + "|SchoolID";

		var reportID = 349;

		//Add output type selector
		var result = this.reportService.Print(reportID, strParam, this.SchoolID, OutputType);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedAttendanceHistory = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedAttendanceHistory = null;
	}
	onRowDblClick(Attendance) {
		this.errorMessage = "";

		this.SelectedAttendanceHistory = Attendance;
		this.onViewAttendance();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////
	IntToDay(i) {
		if (i == 0) {
			return "Sun";
		} else if (i == 1) {
			return "Mon";
		} else if (i == 2) {
			return "Tue";
		} else if (i == 3) {
			return "Wed";
		} else if (i == 4) {
			return "Thu";
		} else if (i == 5) {
			return "Fri";
		} else if (i == 6) {
			return "Sat";
		}
	}
	////////////////////////////////////////////
}
